import React from 'react';

import NoEquipmentFound from 'assets/no_equipment_found.svg?react';
import { useTranslation } from 'react-i18next';

export const EmptyContent: React.FC = () => {
  const { t } = useTranslation();
  return (
    <div className="flex flex-row h-80px py-10" data-testid="empty-content">
      <div className="flex flex-col w-30%">
        <NoEquipmentFound />
      </div>
      <div className="flex flex-col">
        <h2 className="text-brand-syngenta-navy t-16 font-bold">{t('No products found')}</h2>
        <span className="text-neutral-60 t-14 ">
          {t('Check the word you typed or try searching for another word.')}
        </span>
      </div>
    </div>
  );
};
